export const DELETE_VIDEO = Symbol('DELETE_VIDEO');
export const VIDEO_DELETED = Symbol('VIDEO_DELETED');
export const VIDEO_MARK_FEATURED = Symbol('VIDEO_MARK_FEATURED');
export const VIDEO_UNMARK_FEATURED = Symbol('VIDEO_UNMARK_FEATURED');
export const MARK_AS_START_VIDEO = Symbol('MARK_AS_START_VIDEO');
export const UNMARK_AS_START_VIDEO = Symbol('UNMARK_AS_START_VIDEO');
export const FETCH_DOWNLOAD_VIDEO_REQUEST = Symbol('FETCH_DOWNLOAD_VIDEO_REQUEST');
export const FETCH_DOWNLOAD_VIDEO_SUCCESS = Symbol('FETCH_DOWNLOAD_VIDEO_SUCCESS');
export const CREATE_THUMBNAIL_REQUEST = Symbol('CREATE_THUMBNAIL_REQUEST');
export const PULL_THUMBNAIL_REQUEST = Symbol('PULL_THUMBNAIL_REQUEST');
export const REPORT_VIDEO = Symbol('REPORT_VIDEO');

/**
 * @param {string} videoId
 * @param {boolean} confirm
 * @return {{type: symbol, payload: {videoId: string}}}
 */
export const deleteVideoAction = (videoId, confirm = false) => ({
  type: DELETE_VIDEO,
  payload: {
    videoId,
    confirm,
  },
});

/**
 * @param {string} videoId
 * @returns {{type: symbol, payload: {videoId: *}}}
 */
export const videoDeletedAction = (videoId) => ({
  type: VIDEO_DELETED,
  payload: { videoId },
});

/**
 * @param {videoModel.type} video
 * @param {number} pageNumber
 * @param {string} sort
 * @returns {{type: symbol, payload: {videoId: *}}}
 */
export const markVideoFeaturedAction = (video, pageNumber, sort) => ({
  type: VIDEO_MARK_FEATURED,
  payload: {
    video,
    pageNumber,
    sort,
  },
});

/**
 * @param {videoModel.type} video
 * @param {number} pageNumber
 * @param {string} sort
 * @returns {{type: symbol, payload: {videoId: *}}}
 */
export const unMarkVideoFeaturedAction = (video, pageNumber, sort) => ({
  type: VIDEO_UNMARK_FEATURED,
  payload: {
    video,
    pageNumber,
    sort,
  },
});

/**
 * @param {videoModel.type} video
 * @param {string} channelId
 * @param {number} pageNumber
 * @param {string} sort
 * @returns {{payload: {video, pageNumber, sort}, type: symbol}}
 */
export const markAsStartVideoAction = (video, channelId, pageNumber, sort) => ({
  type: MARK_AS_START_VIDEO,
  payload: {
    video,
    channelId,
    pageNumber,
    sort,
  },
});

/**
 * @param {videoModel.type} video
 * @param {string} channelId
 * @param {number} pageNumber
 * @param {string} sort
 * @returns {{payload: {video, pageNumber, sort}, type: symbol}}
 */
export const unMarkAsStartVideoAction = (video, channelId, pageNumber, sort) => ({
  type: UNMARK_AS_START_VIDEO,
  payload: {
    video,
    channelId,
    pageNumber,
    sort,
  },
});

/**
 * @param {string} videoId
 * @returns {{payload: {videoId: *}, type: symbol}}
 */
export const fetchDownloadVideoRequestAction = (videoId) => ({
  type: FETCH_DOWNLOAD_VIDEO_REQUEST,
  payload: {
    videoId,
  },
});

/**
 * @param {videoModel.type} video
 * @returns {{payload: {video: *}, type: symbol}}
 */
export const fetchDownloadVideoSuccessAction = (video) => ({
  type: FETCH_DOWNLOAD_VIDEO_SUCCESS,
  payload: {
    video,
  },
});

/**
 * @param {string} videoId
 * @param {number} timestamp - milliseconds
 * @return {{payload: {videoId: string, timestamp: number}, type: symbol}}
 */
export const generateThumbnailRequestAction = (videoId, timestamp) => ({
  type: CREATE_THUMBNAIL_REQUEST,
  payload: {
    videoId,
    timestamp,
  },
});

/**
 * @param {string} videoId
 * @param {number} thumbnailId
 * @return {{payload: {videoId, string, thumbnailId: string}, type: *}}
 */
export const pullThumbnailRequestAction = (videoId, thumbnailId) => ({
  type: PULL_THUMBNAIL_REQUEST,
  payload: {
    videoId,
    thumbnailId,
  },
});

/**
 * @param {string} videoId
 * @param {string} message
 * @param {string} path
 * @returns {{payload: {message: string, path: string}, type: symbol}}
 */
export const reportVideoAction = (videoId, message, path) => ({
  type: REPORT_VIDEO,
  payload: {
    videoId,
    message,
    path,
  },
});
